// src/CourseDetail.js
import React from "react";

const CourseDetail = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg m-4 h-auto">
      <div className="container mx-auto px-8 py-8">
        <h1 className="text-[20px] font-bold text-[#400167] mb-6 font-satoshi">
          Course Details
        </h1>
        <div className="flex gap-6">
          <div className="w-1/2 pr-6">
            <img
              src="/assets/Leadership.png"
              alt="Course"
              className="mb-4 rounded w-full h-auto"
            />
            <p className="text-[14px] text-[#262627] font-satoshi ">
              Learning Duration: <span className="font-bold">120 minutes</span>
            </p>
          </div>
          <div
            className=" pl-6 border rounded-lg w-[506px] h-[665px] py-10"
            style={{ borderColor: "rgba(2, 105, 208, 0.5)" }}
          >
            <h2 className="text-[28px] text-[#400167] font-bold mb-4 font-satoshi">
              Module Title
            </h2>
            <div className="w-full text-[15px] text-[#000000] font-[300] leading-[30px]">
              <p className="mb-6">
                Lorem ipsum dolor sit amet consectetur. Nibh imperdiet laoreet
                condimentum scelerisque dui eget faucibus vel mauris. Id.
              </p>
              <h3 className="text-[28px] text-[#400167] font-bold mb-6 font-satoshi">
                What You will Learn
              </h3>
              <p className="mb-4 ">
                Lorem ipsum dolor sit amet consectetur. In scelerisque
                scelerisque quis venenatis. Tempor tristique fames felis
                eleifend tortor pharetra pharetra. Elit vitae lorem faucibus
                eget nulla ipsum. Eget vulputate mi integer feugiat nisl. Morbi
                sagittis non in felis. Vel scelerisque sapien adipiscing etiam
                eget risus. Nisi quam sed ipsum sagittis tincidunt dui nunc
                volutpat. Consectetur gravida adipiscing eget eu pellentesque
                dignissim ut. Sagittis gravida nulla et facilisi mi tincidunt
                viverra amet.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetail;
